<template>
  <i v-if="check" class="fa fa-spin" :class="loadingClass"></i>
</template>
<script>
  export default{
    props: {
      type: {
        type: String,
        default: 'spinner'
      },
      check: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      loadingClass () {
        // spinner
        // circle-o-notch
        // refresh
        return `fa-${this.type}`
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/LoadingSpin.vue